export const USER_AUTH_REQUEST = 'USER_AUTH_REQUEST';
export const USER_AUTH_SUCCESS = 'USER_AUTH_SUCCESS';
export const USER_AUTHADM_REQUEST = 'USER_AUTHADM_REQUEST';
export const USER_AUTHADM_SUCCESS = 'USER_AUTHADM_SUCCESS';
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_DATA_REQUEST = 'USER_DATA_REQUEST';
export const USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const FORM_REQUEST = 'FORM_REQUEST';
export const DADOS_PESSOAIS_REQUEST = 'DADOS_PESSOAIS_REQUEST';
export const DADOS_PESSOAIS_SUCCESS = 'DADOS_PESSOAIS_SUCCESS';
export const FORMULARIO_ENVIADO = 'FORMULARIO_ENVIADO';
export const FORMULARIO_RESET = 'FORMULARIO_RESET';
export const ALTERAR_PLANO_USUARIO_REQUEST = 'ALTERAR_PLANO_USUARIO_REQUEST';
export const GERAR_PROTOCOLO_REQUEST = 'GERAR_PROTOCOLO_REQUEST';
export const GERAR_PROTOCOLO_SUCCESS = 'GERAR_PROTOCOLO_SUCCESS';
export const CREATE_DRAFT_REQUEST = 'CREATE_DRAFT_REQUEST';
export const UPDATE_DRAFT = 'UPDATE_DRAFT';
export const ADD_DRAFT_ITEM = 'ADD_DRAFT_ITEM';
export const UPDATE_DRAFT_ITEM = 'UPDATE_DRAFT_ITEM';
export const DELETE_DRAFT_ITEM = 'DELETE_DRAFT_ITEM';
export const FINISH_FORM = 'FINISH_FORM';
export const UPDATE_ATTACHMENT_REQUEST = 'UPDATE_ATTACHMENT_REQUEST';
export const ADD_CNPB_AND_PLAN_NAME = 'ADD_CNPB_AND_PLAN_NAME';
export const OBTER_PAGINAS_DISPONIVEIS_EXTRATO_SUCCESS =
  'OBTER_PAGINAS_DISPONIVEIS_EXTRATO_SUCCESS';
export const OBTER_PAGINAS_DISPONIVEIS_EXTRATO_REQUEST =
  'OBTER_PAGINAS_DISPONIVEIS_EXTRATO_REQUEST';
export const ATUALIZAR_DADOS_CADASTRAIS_REQUEST =
  'ATUALIZAR_DADOS_CADASTRAIS_REQUEST';
export const REQUEST_SOLICITACAO_DE_EMPRESTIMO =
  'REQUEST_SOLICITACAO_DE_EMPRESTIMO';
export const RESET_USER = 'RESET_USER';
export const FALE_CONOSCO_REQUEST = 'FALE_CONOSCO_REQUEST';
export const OBTER_PENDENCIAS_USUARIO_REQUEST =
  'OBTER_PENDENCIAS_USUARIO_REQUEST';
export const OBTER_PENDENCIAS_USUARIO_SUCCESS =
  'OBTER_PENDENCIAS_USUARIO_SUCCESS';
